export default () => ({
  currentHealthActions: [],
  choosenHealthActions: undefined,
  rolesList: [
    { id: 'DIGITAL_CARE_NURSE', name: 'Enfermeiro(a) Alice Agora' },
    {
      id: 'HEALTHCARE_TEAM_NURSE',
      name: 'Enfermeiro(a) Time de Saúde'
    },
    {
      id: 'MANAGER_PHYSICIAN',
      name: 'Médico(a) Gestor(a)'
    },
    {
      id: 'CARE_COORD_NURSE',
      name: 'Enfermeiro(a) de Coordenação de Cuidados'
    }
  ]
})
